import appStore from 'utilities/store';
import Keys from 'stateKeys';
import isStringSet from 'utilities/is/isStringSet';

const DEFAULT_TIME_MINS = 30;

// eslint-disable-next-line no-undef
const configuredTime = Number(process.env.REACT_APP_BACKGROUND_FETCH_POLL_TIME_MINS);

const minutesToMillis = (minutes) => 1000 * 60 * minutes;

// Convert poll frequency to milliseconds
let pollFrequency = minutesToMillis(configuredTime || DEFAULT_TIME_MINS);

const worker = new Worker(new URL('./supervisor.worker.js', import.meta.url));

function send(message) {
    worker.postMessage(JSON.stringify(message));
}

export function init(store) {    

    if (!store || !store.getState) {
        console.error('mediator init store is null');
        return;
    }

    worker.addEventListener("message", event => {
        const { type, message } = JSON.parse(event.data);

        console.log(`[${new Date().toLocaleTimeString()}] Mediator received message with type: ${type}`);

        store.dispatch({type, ...message });
    });

    const token = appStore.get(Keys.Auth.TokenKey);
    const userQrCode = appStore.get('state:user');

    if (isStringSet(token)) {
        updateToken(token);
    }

    const { location, supervisor, cards, config } = store.getState();
    let serialNumber = null;

    if (isStringSet(userQrCode)) {
        const card = cards.cards[userQrCode];
        if (card && card.serialNumber) {
            serialNumber = card.serialNumber;
        }
    }    

    start({ 
        divisionLastDownloaded: (supervisor || {}).divisionLastDownloaded, 
        location,
        serialNumber,
        checksum: (supervisor || {}).checksum,
        pollFrequency: minutesToMillis(config.clientCacheDurationMinutes) || pollFrequency
    });
}

export function updateLocation(location) {
    send({ type: 'UPDATE_POLL_STATE', message: { location } });
}

export function updateCardSerial(serialNumber) {
    send({ type: 'UPDATE_POLL_STATE', message: { serialNumber } });
}

export function updatePollFrequency(pollFrequency) {
    send({ type: 'UPDATE_POLL_STATE', message: { pollFrequency : minutesToMillis(pollFrequency) } });
}

export function stop() {
    send({type: 'STOP_POLLING', message: {}});
}

export function start(data) {
    send({ type: 'START_POLLING', message: { pollFrequency, ...data }});
}

export function updateToken(token) {
    send({
        type: 'UPDATE_ACCESS_TOKEN',
        message: { token: token }
    });
}